import React, { useEffect, useState, useContext } from 'react';
import moment from 'moment';
import InfiniteScroll from '../../InfiniteScroll/InfiniteScroll';
import { tableContainer } from './BalanceOverview.module.css';
import {
  getBalanceOverview,
  getMinMaxAvg
} from '../../../constants/bank-statement-api';
import CircularProgress from '@material-ui/core/CircularProgress';
import { get } from 'lodash';
import { LeadData } from '../../UploadedBankStatements/ManullyAddBankStaatements/ManuallyAddBankStatement';
import numberFormat from '../../../constants/NumberFormat';

const headings = [
  {
    name: 'Balance view',
    key: 'Balance view'
  },
  {
    name: 'Balance on 10th',
    key: 'Balance on 10th'
  },
  {
    name: 'Balance on 20th',
    key: 'Balance on 20th'
  },
  {
    name: 'Min. EOD Balance',
    key: 'Min. EOD Balance'
  },
  {
    name: 'Avg. EOD Balance',
    key: 'Avg. EOD Balance'
  },
  {
    name: 'Max. EOD Balance',
    key: 'Max. EOD Balance'
  },
  {
    name: 'Balance on last day of month',
    key: 'Balance on last day of month'
  }
];

function BalanceOverview() {
  const leadDetails = useContext(LeadData);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [pageMetadata, setPageMetadata] = useState({ total_data: 0 });

  const balanceOverView = async ({ day, pageNum }) => {
    setLoading(true);
    return getBalanceOverview({
      days: day,
      leadId: leadDetails?.leadId,
      applicantId: leadDetails?.applicantId,
      docId: leadDetails?.docId,
      pageNumber: pageNum || pageNumber,
      pageSize
    })
      .then(res => {
        if (typeof res !== 'object') return;
        return res?.users_per_page;
      })
      .catch(() => {
        return [];
      });
  };

  const getmonthsMetaData = async pageNum => {
    setLoading(true);

    return getMinMaxAvg({
      leadId: leadDetails?.leadId,
      applicantId: leadDetails?.applicantId,
      docId: leadDetails?.docId,
      pageNumber: pageNum || pageNumber,
      pageSize
    }).then(res => {
      if (typeof res === 'object') {
        setPageMetadata({ total_data: res?.total_data });
        try {
          let minData = res?.users_per_page_min;
          let maxData = res?.users_per_page_max;
          let avgData = res?.users_per_page_mean;
          return { minData, maxData, avgData };
        } catch (error) {
          return [];
        }
      }
    });
  };

  const getSingleSourceValue = data => {
    addData({ ...data });
  };

  const getValues = async ({ pageNum }) => {
    let bal10 = await balanceOverView({ day: 10, pageNum });
    let bal20 = await balanceOverView({ day: 20, pageNum });
    let bal30 = await balanceOverView({ day: 'eom', pageNum });
    let { minData, maxData, avgData } = await getmonthsMetaData(pageNum);

    getSingleSourceValue({
      bal10,
      bal20,
      bal30,
      minData,
      maxData,
      avgData
    });
  };

  useEffect(() => {
    getValues({});
  }, []);

  const addData = ({ bal10, bal20, bal30, minData, maxData, avgData }) => {
    let newData = [];
    Object.values(avgData).map((result, index) => {
      let month = result?.[1]?.month;
      let year = result?.[1]?.year;
      let currClosingbal10 = bal10?.find(each => {
        if (each?.[1]?.month === month && each?.[1]?.year === year) return each;
      });
      let currClosingbal20 = bal20?.find(each => {
        if (each?.[1]?.month === month && each?.[1]?.year === year) return each;
      });
      let currClosingbal30 = bal30?.find(each => {
        if (each?.[1]?.month === month && each?.[1]?.year === year) return each;
      });

      let currClosingbalMin = minData?.find(each => {
        if (each?.[1]?.month === month && each?.[1]?.year === year) return each;
      });

      let currClosingbalMax = maxData?.find(each => {
        if (each?.[1]?.month === month && each?.[1]?.year === year) return each;
      });

      newData.push({
        month: month,
        year: year,
        balanceOn10th: parseInt(
          get(currClosingbal10, '[1].closing_balance', 0)
        ),
        balanceOn20th: parseInt(
          get(currClosingbal20, '[1].closing_balance', 0)
        ),
        minBalance: parseInt(get(currClosingbalMin, '[1].closing_balance', 0)),
        avgBalance: parseInt(get(result, '[1].closing_balance', 0)),
        maxBalance: parseInt(get(currClosingbalMax, '[1].closing_balance', 0)),
        lastDayBalance: parseInt(
          get(currClosingbal30, '[1].closing_balance', 0)
        )
      });
    });
    setLoading(false);

    setData(e => [...e, ...newData]);
  };

  const handlePagnation = () => {
    if (pageSize * pageNumber >= pageMetadata.total_data) return;

    if (loading) return;
    getValues({ pageNum: pageNumber + 1 });
    setPageNumber(e => e + 1);
  };
  return (
    <div className="w-full">
      <div className="w-full mt-5 bg-white py-3 px-3 rounded">
        <p className="text-lg text-black-500 mb-3 font-bold">
          Balance Overview
        </p>
        <hr className="w-full my-3" style={{ borderColor: '#dee0f0' }} />
        <InfiniteScroll
          bottomLocation={40}
          handleScrollsuccess={handlePagnation}
          showDefaultLoader={false}
        >
          <div className={`${tableContainer} w-full`}>
            <table className="table-auto">
              <thead className="text-grey-600">
                <tr>
                  {headings.map(heading => (
                    <th
                      style={{ border: 'solid lightgray 1px' }}
                      className="px-1"
                    >
                      {heading.name}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data.map((val, index) => (
                  <tr className="h-12">
                    <td
                      style={{ border: 'solid lightgray 1px' }}
                      className="text-center px-1"
                    >
                      {`${moment(val?.month, 'MM').format('MMM')}, ${
                        val?.year
                      }`}
                    </td>
                    <td
                      style={{ border: 'solid lightgray 1px' }}
                      className="text-center px-1"
                    >
                      <span className="mr-1">₹</span>
                      <span>
                        {val.balanceOn10th
                          ? numberFormat(val.balanceOn10th)
                          : '---'}
                      </span>
                    </td>
                    <td
                      style={{ border: 'solid lightgray 1px' }}
                      className="text-center px-1"
                    >
                      <span className="mr-1">₹</span>
                      <span>
                        {val.balanceOn20th
                          ? numberFormat(val.balanceOn20th)
                          : '---'}
                      </span>
                    </td>
                    <td
                      style={{ border: 'solid lightgray 1px' }}
                      className="text-center px-1"
                    >
                      <span className="mr-1">₹</span>
                      <span>
                        {val.minBalance ? numberFormat(val.minBalance) : '---'}
                      </span>
                    </td>
                    <td
                      style={{ border: 'solid lightgray 1px' }}
                      className="text-center px-1"
                    >
                      <span className="mr-1">₹</span>
                      <span>
                        {val.avgBalance ? numberFormat(val.avgBalance) : '---'}
                      </span>
                    </td>
                    <td
                      style={{ border: 'solid lightgray 1px' }}
                      className="text-center px-1"
                    >
                      <span className="mr-1">₹</span>
                      <span>
                        {val.maxBalance ? numberFormat(val.maxBalance) : '---'}
                      </span>
                    </td>
                    <td
                      style={{
                        border: 'solid lightgray 1px',
                        maxWidth: '100px'
                      }}
                      className="text-center px-1"
                    >
                      <span className="mr-1">₹</span>
                      <span>
                        {val.lastDayBalance
                          ? numberFormat(val.lastDayBalance)
                          : '---'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </InfiniteScroll>

        {loading && (
          <div className="mx-auto table items-center mt-8">
            <CircularProgress />
          </div>
        )}
        {!loading && data.length === pageMetadata?.total_data && (
          <div className="mx-auto table items-center mt-8">
            {data?.length === 0 && 'No data to show!'}
            {data?.length !== 0 && 'No more data to show!'}
          </div>
        )}
      </div>
    </div>
  );
}

export default BalanceOverview;
